export default __webpack_public_path__ + "locales/hy-AM/ChangePortalOwner.json?hash=e84fc68d853f0c10a64277f526641bb5";